const AHome = () => import(/* webpackChunkName:"chunk-policy" */ '@/views/P3_Page/AHome.vue')
const PrivacyPolicy = () => import(/* webpackChunkName:"chunk-policy" */ '@/views/P3_Page/PrivacyPolicy.vue')
const UserProtocol = () => import(/* webpackChunkName:"chunk-policy" */ '@/views/P3_Page/UserProtocol.vue')
const ChildSafetyPolicy = () => import(/* webpackChunkName:"chunk-policy" */ '@/views/P3_Page/ChildSafetyPolicy.vue')

// 历史路由
// prettier-ignore
const historyRoutes = [
  // echo
  {
    path: '/docs/iOS/privacy-protocol', name: 'privacypolicy', component: PrivacyPolicy
  },
  {
    path: '/docs/iOS/user-protocol', name: 'userprotocol', component: UserProtocol
  },
  // joychat
  {
    path: '/joychat-privacy', name: 'privacypolicy', component: PrivacyPolicy
  },
  {
    path: '/joychat-user', name: 'userprotocol', component: UserProtocol
  },
  // kiko
  {
    path: '/docs/kiko/privacy-protocol', name: 'privacypolicy', component: PrivacyPolicy
  },
  {
    path: '/docs/kiko/user-protocol', name: 'userprotocol', component: UserProtocol
  },
  // vava
  {
    path: '/privacy-agreement', name: 'privacypolicy', component: PrivacyPolicy
  },
  {
    path: '/user-agreement', name: 'userprotocol', component: UserProtocol
  },
  // vibeo
  {
    path: '/docs/vibeo/privacy-protocol', name: 'privacypolicy', component: PrivacyPolicy
  },
  {
    path: '/docs/vibeo/user-protocol', name: 'userprotocol', component: UserProtocol
  }
]

// 新统一路由
// prettier-ignore
const commonRoutes = [
  {
    path: '/home', name: 'home', component: AHome
  },
  {
    path: '/privacy-policy', name: 'privacypolicy', component: PrivacyPolicy
  },
  {
    path: '/user-protocol', name: 'userprotocol', component: UserProtocol
  },
  {
    path: '/child-safety-policy', name: 'childsafetypolicy', component: ChildSafetyPolicy
  }
]

const routes = [...historyRoutes, ...commonRoutes]

export default routes
